import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCalendarOutline } from './svg/calendar-outline.svg.js';

/**
 * @param {boolean} legacyBoundingBox - This is not recommended but is present for backward compatibility. If used, it will render icons more like previous versions where the icon always had a 24x24 pixel bounding box. This only applies for icons with a `size` prop of 12, 16 or 20. For icons that are already 24px or larger, this prop will be ignored.
 * @param {number} size - (optional) can be one of `12`, `16`, `20`, `24`, or `32` (defaults to `24`).
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
var Calendar = function (props) {
    var title = props.title, _a = props.size, size = _a === void 0 ? 24 : _a, legacyBoundingBox = props.legacyBoundingBox, rest = __rest(props, ["title", "size", "legacyBoundingBox"]);
    var dimensions = size;
    var viewBoxValue = '0 0 24 24';
    if (legacyBoundingBox && size < 24) {
        dimensions = 24;
        if (size === 12) {
            viewBoxValue = '-6 -6 36 36';
        }
        if (size === 16) {
            viewBoxValue = '-4 -4 32 32';
        }
        if (size === 20) {
            viewBoxValue = '-2.5 -2.5 29 29';
        }
    }
    return (jsx(SvgCalendarOutline, __assign({ viewBox: viewBoxValue, "aria-label": title, role: "img" }, rest, { width: "".concat(dimensions), height: "".concat(dimensions), "data-pp-icon": "Calendar" })));
};

export { Calendar as default };
//# sourceMappingURL=Calendar.js.map
